/**
 * @generated SignedSource<<0ef586bb8e7ebee9edaa0c3b8d23b812>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CreateButton$data = {
  readonly canCreateProject: boolean | null | undefined;
  readonly shouldDisplay?: boolean | null | undefined;
  readonly " $fragmentType": "CreateButton";
};
export type CreateButton$key = {
  readonly " $data"?: CreateButton$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreateButton">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "CreateButton",
  "selections": [
    {
      "alias": "canCreateProject",
      "args": [
        (v0/*: any*/),
        {
          "kind": "Literal",
          "name": "type",
          "value": "CREATE_PROJECT"
        }
      ],
      "kind": "ScalarField",
      "name": "canPerform"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "shouldDisplay",
          "args": [
            (v0/*: any*/),
            {
              "kind": "Literal",
              "name": "type",
              "value": "VIEW_PROJECT_CREATION_ENTRY"
            }
          ],
          "kind": "ScalarField",
          "name": "canPerform"
        }
      ]
    }
  ],
  "type": "JiraQuery"
};
})();

(node as any).hash = "068f8b2b2088cb5bfa0d411aa85c4559";

export default node;
